<ng-container *ngIf="!nzOption.nzCustomContent; else nzOption.template">
  {{nzOption.nzLabel}}
</ng-container>
<ng-container *ngIf="nzSelectService.isMultipleOrTags">
  <i nz-icon nzType="check" class="ant-select-selected-icon" *ngIf="!nzMenuItemSelectedIcon; else nzMenuItemSelectedIcon"></i>
</ng-container>
